import React from 'react';
import TcScanQrBtn from './TcScanQrBtn';

function TcScanQrCodeBar({ classNameStyle = "" }: { classNameStyle?: string }) {
    return (
        <div className={`tc-scan-qr-code-bar flex items-center justify-center h-1 z-20 ${classNameStyle}`}>
            <TcScanQrBtn 
                classNameStyle="-mt-[120px]"
            />
        </div>
    )
}

export default TcScanQrCodeBar;